export const soulList = [
  {
    id: 4,
    name: '风神 -- 埃俄罗斯',
    attrs: '风技能等级 + 1；风属性伤害加成 + 10%',
    type: 'success',
  },
  {
    id: 5,
    name: '火神 -- 赫菲斯托斯',
    attrs: '火技能等级 + 1；火属性伤害加成 + 10%',
    type: 'danger',
  },
  {
    id: 6,
    name: '水神 -- 波塞冬',
    attrs: '水技能等级 + 1；水属性伤害加成 + 10%',
    type: 'primary',
  },
  {
    id: 7,
    name: '土神 -- 盖亚',
    attrs: '土技能等级 + 1；土属性伤害加成 + 10%',
    type: 'warning',
  },
]

export const soulClass: Record<number, string> = {
  4: 'wind-god',
  5: 'fire-god',
  6: 'water-god',
  7: 'soil-god',
}
